import { Configuration, LogLevel } from "@azure/msal-browser";


export const msalConfig: Configuration = {
  auth: {
    authority: import.meta.env.VITE_MSAL_AUTHORITY,
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    // MSAL's own renewal reason (interaction_required / login_required /
    // monitor_window_timeout) was previously invisible, so diagnosing a forced
    // logout was guesswork. Surface warnings + errors to the console so the next
    // incident is legible. Bump logLevel to Verbose temporarily when reproducing.
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) console.error("[msal]", message);
        else if (level === LogLevel.Warning) console.warn("[msal]", message);
      },
    },
  },
};